<template>
  <div id="debugPanel" class="debug-panel" refs="debugPanel" :class="{'expand': expand,}">
    <div class="debug-header">
      {{'User Info'}}
      <div @click="handleDebugExpand()" class="debug-arrow">
        <el-icon>
          <ArrowLeft v-if="expand" />
          <ArrowRight v-else />
        </el-icon>
      </div>
      <div v-if="!expand" @click="handleDebugExpand()" class="header-cover"></div>
    </div>
    <perfect-scrollbar class="debug-content cstm-ps-scrollbar-vertical">
      <el-collapse id="debugCollapse" v-model="activeNames" @change="handleChange">
        <el-collapse-item title="Current Plan" name="1">
         <pre v-if="getPlan !== null">
           <code>{{getPlan}}</code>
          </pre>
        </el-collapse-item>
        <el-collapse-item title="User info from LocalStorage" name="2">
         <pre>
           <code>{{$currentUser.getUserDetails()}}</code>
          </pre>
        </el-collapse-item>
        <el-collapse-item title="User Groups" name="3">
          <code>{{$currentUser.getUserGroups()}}</code>
        </el-collapse-item>
        <el-collapse-item title="User Rights" name="4">
          <pre>
            <code>{{$currentUser.getRights()}}</code>
          </pre>
        </el-collapse-item>
        <el-collapse-item title="Token" name="5">
          <pre>
            <code> {{userSession}} </code>
          </pre>
        </el-collapse-item>
        <el-collapse-item title="Refresh User Session" name="6" class="test-token-request">
          <el-button class="cstm-btn-white" @click="refreshUserSession()">{{'GET NEW SESSION'}}</el-button>
        </el-collapse-item>
        <el-collapse-item title="Revoke User Refresh Token" name="7" class="test-token-revoke">
          <el-button class="cstm-btn-white" @click="performRevokeRefreshToken()">{{'REVOKE REFRESH TOKEN'}}</el-button>
        </el-collapse-item>
      </el-collapse>
    </perfect-scrollbar>
  </div>
</template>

<script src="./debug-panel.js"></script>
<style lang="scss" src="./debug-panel.scss"></style>
